// Module
var code = "<button type=\"button\" class=\"popover-close icon-cerrar hidden-lg hidden-xl\" ng-click=\"popoverCtrl.close()\">\n    <span class=\"u-hide-accessible\">{{'POP_OVER_ACCESSIBILITY_CLOSE'|translate}}</span>\n</button>\n<p class=\"ib-text ib-text--color-light\">{{popoverCtrl.text|translate}}</p>";
// Exports
module.exports = code;